/* eslint-disable */
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import jwt_decode from "jwt-decode";
import store from "../../store/index";
import auth0 from "auth0-js";
import VueApexCharts from 'vue3-apexcharts';
import { ref, computed, onBeforeMount, onMounted } from "vue";
import moment from "moment";
import rbqmNavbar from "../rbqmNavbar/rbqmNavbar.vue";
import customModal from "../customModal/customModal.vue";
import manageRiskRegisterModal from "../ManageRiskRegisterModal/ManageRiskRegisterModal.vue";

export default {
    name: "rbqmdashboard",
    components: {
        apexchart: VueApexCharts,
        rbqmNavbar: rbqmNavbar,
        customModal:customModal,
        manageRiskRegisterModal: manageRiskRegisterModal
    },
    setup() {
        const riskDetails = ref({});
        const showModal = ref(false);
        const modalData = ref({});
        const showRiskRegisterModal = ref(false);

      async function CreateRiskClicked(scoreId) {
        if(this.riskDetails.isFlagged == false){
            await this.addRiskRegister(scoreId);
        }else{
            this.riskRegisterId = this.riskDetails.riskRegId;
        }
        showRiskRegisterModal.value = true;
      }  
      async function closeRiskReg() {
        // alert("close");
        showRiskRegisterModal.value = false;
      }
      async function openModal(rowKey) {
     console.log("RiskScore ID:", rowKey);
      const details = await getRiskDetailsById(rowKey);
    const entity = selectedRows.value.find(row => row.id === rowKey);
    if (entity) {
        // Set modal data to the row object (all details already present)
        modalData.value = { ...entity };
        showModal.value = true;
    }
      }
      function closeModal() {
            showModal.value = false;
            modalData.value = {};
            riskDetails.value= {};
      }
      async function getRiskDetailsById(id) {
    const idtoken = store.getters.getIdToken;
    try {
        const res = await axios.get(
            `${baseurl}/forms/rbqm/getriskdetailsbyid?id=${id}`,
            {
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
            }
        );
       
        riskDetails.value = res.data;
         console.log("RislDetails",riskDetails.value)
        return res.data; 
        
    } catch (err) {
        console.log(err);
        return null;
    }
      }
      async function updateRiskScore(rowKey) {
  const idtoken = store.getters.getIdToken;
  try {
    const payload = {
      id: rowKey,
      examplesforHighMediumLowRisk: riskDetails.value.examplesforHighMediumLowRisk,
      functionalPlanImpacted: riskDetails.value.functionalPlanImpacted,
      rationaleForRiskLevel: riskDetails.value.rationaleForRiskLevel
    };

    const res = await axios.put(
      `${baseurl}/forms/rbqm/updateriskscore`,
      payload,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json"
        }
      }
    );
     alert("Risk details updated successfully!");
    console.log("Update success:", res.data);
    
  } catch (err) {
    alert("An error occurred while updating risk details."); 
    console.error("Update failed:", err);
  }
      }
      async function addRiskRegister(riskScoreID) {
        const idtoken = store.getters.getIdToken;
        try {
            const res = await axios.post(
            `${this.baseurl}/forms/riskregister/createriskregister`,
            { "riskScoreId": riskScoreID },
            {
                headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
                },
            }
            );
            console.log("created...........", res.data);
            this.riskRegisterId = res.data;
            } catch (err) {
                console.log("error in adding risk register", err);
            }
        }
        const router = useRouter();
        let currentTheme = ref(localStorage.getItem("theme-color"));
        const selectedRows = ref([]);
        const riskRegisterId =  ref("");
        let sites = ref([]);
        let selectedSiteId = ref("");
        const baseurl = process.env.VUE_APP_Service_URL;
        

        async function getsites() {
                  const idtoken = store.getters.getIdToken;
                  const currentstudy = store.getters.getStudyIs;
                  await axios
                    .get(`${baseurl}/management/site/getallsitesbyuser?studyId=${currentstudy}&getAll=false`, {
                      headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                      },
                    })
                    .then((res) => {
                      const list = Array.isArray(res.data)
                        ? res.data
                        : [];

                        sites.value = list;
                    })
                    .catch((err) => {
                      console.log(err);
                    });
        }
        function normalizeInt(v) {
            const n = Number(v);
            return Number.isFinite(n) ? n : 0;
        }

        function levelToClass(label, score) {
            const s = (label || '').toString().toLowerCase();
            if (s.includes('low')) return 'green';
            if (s.includes('med') || s.includes('moderate') || s.includes('amber')) return 'amber';
            if (s.includes('high')) return 'red';
            if (score <= 1) return 'green';
            if (score === 2) return 'amber';
            return 'red';
        }

        function pickLatestScore(scores) {
            if (!Array.isArray(scores) || scores.length === 0) return null;
            const preferred = scores.filter(s => s && s.isLatest);
            const pool = preferred.length ? preferred : scores.slice();

            pool.sort((a, b) => {
                const ad = a && a.CreatedAt ? new Date(a.CreatedAt).getTime() : 0;
                const bd = b && b.CreatedAt ? new Date(b.CreatedAt).getTime() : 0;
                if (bd !== ad) return bd - ad;

                const av = Number(a && a.version != null ? a.version : 0); // ⬅️ was a?.version ?? 0
                const bv = Number(b && b.version != null ? b.version : 0); // ⬅️ was b?.version ?? 0
                return bv - av;
            });

            return pool[0];
        }

       function onSubCategorySelected(payload) {
      
  const rows = [];
  const items = payload && Array.isArray(payload.items) ? payload.items : [];
  console.log("items",items)
  for (const it of items) {
    const score = Number(it.score) || 0;
    const impact = Number(it.impactPoint) || 0;
    const probability = Number(it.probabilityPoint) || 0;
    const detectability = Number(it.detectabilityPoint) || 0;

    const color = (typeof it.riskLevelColor === 'string' && it.riskLevelColor.trim())
      ? it.riskLevelColor.trim()
      : '#87D37C';

    rows.push({
      key: `${it.discussionDetails || ''}::${it.id || it.orderNo || Math.random()}`,
      orderNo: it.orderNo != null ? it.orderNo : '',
      detail: it.discussionDetails || '', 
      riskIndicator:it.riskIndicator, // your template uses row.detail
      score,
      impact,
      probability,
      detectability,
      color,
      id:it.id
    });
  }

  // Optional: sort by orderNo
  rows.sort((a, b) => Number(a.orderNo || 0) - Number(b.orderNo || 0));
  selectedRows.value = rows;
       }


        function levelToClass(score) {
            const s = Number(score) || 0;
            if (s <= 9) return 'green';     // < = 9  → green
            if (s <= 18) return 'amber';    // 10–18  → amber
            return 'red';                   // 19–27  → red
        }
        // Chart data and options
        const dqaAllScatterOptions = ref({
            chart: {
                type: 'scatter',
                zoom: {
                    enabled: true
                }
            },
            title: {
                text: 'DIS vs Patient visits per center',
                align: 'left'
            },
            xaxis: {
                title: {
                    text: 'DIS'
                },
                tickAmount: 10
            },
            yaxis: {
                title: {
                    text: 'Patient Visits'
                }
            },
            colors: ['#3a7af0'],
            markers: {
                size: 8,
                strokeWidth: 0,
                hover: {
                    size: 10
                }
            }
        });

        const dqaAllScatterSeries = ref([{
            name: 'Centers',
            data: [
                { x: 15, y: 120 },
                { x: 25, y: 80 },
                { x: 35, y: 60 },
                { x: 45, y: 100 },
                { x: 55, y: 40 },
                { x: 65, y: 90 },
                { x: 75, y: 30 }
            ]
        }]);

        const dqaAllBarOptions = ref({
            chart: {
                type: 'bar'
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '70%',
                    endingShape: 'rounded'
                }
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: ['Green', 'Yellow', 'Red']
            },
            colors: ['#28a745', '#ffc107', '#dc3545']
        });

        const dqaAllBarSeries = ref([{
            name: 'Centers',
            data: [45, 20, 9]
        }]);

        const dqaCriticalScatterOptions = ref({
            chart: {
                type: 'scatter',
                zoom: {
                    enabled: true
                }
            },
            title: {
                text: 'DIS vs Patients per center',
                align: 'left'
            },
            xaxis: {
                title: {
                    text: 'DIS'
                },
                tickAmount: 10
            },
            yaxis: {
                title: {
                    text: 'Patients'
                }
            },
            colors: ['#ff6b6b'],
            markers: {
                size: 8,
                strokeWidth: 0,
                hover: {
                    size: 10
                }
            }
        });

        const dqaCriticalScatterSeries = ref([{
            name: 'Centers',
            data: [
                { x: 10, y: 50 },
                { x: 20, y: 30 },
                { x: 30, y: 20 },
                { x: 40, y: 45 },
                { x: 50, y: 15 },
                { x: 60, y: 40 },
                { x: 70, y: 10 }
            ]
        }]);

        const dqaCriticalBarOptions = ref({
            chart: {
                type: 'bar'
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '70%',
                    endingShape: 'rounded'
                }
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: ['Green', 'Yellow', 'Red']
            },
            colors: ['#28a745', '#ffc107', '#dc3545']
        });

        const dqaCriticalBarSeries = ref([{
            name: 'Centers',
            data: [30, 10, 4]
        }]);

        onMounted(() => {
      getsites();
       window.addEventListener("studyIdChanged", async (event) => {
        getsites();
      });
    });

        onBeforeMount(async () => {
            store.dispatch("setNavbar", false);
            document.getElementById("page-wrapper").style.width = "100%";
            if (currentTheme.value == null) {
                localStorage.setItem("theme-color", "theme-default");
                currentTheme.value = localStorage.getItem("theme-color");
            }
        });

        router.beforeEach((to, from, next) => {
            if (to.name != "profileSettings" && to.name != "fhirViewer") {
                store.dispatch("setNavbar", true);
                document.getElementById("page-wrapper").style.removeProperty("width");
            } else {
                document.getElementById("page-wrapper").style.width = "100%";
            }
            next();
        });

        return {
            showRiskRegisterModal,
            riskDetails,
            showModal,
            modalData,
            currentTheme,
            dqaAllScatterOptions,
            dqaAllScatterSeries,
            dqaAllBarOptions,
            dqaAllBarSeries,
            dqaCriticalScatterOptions,
            dqaCriticalScatterSeries,
            dqaCriticalBarOptions,
            dqaCriticalBarSeries,
            selectedRows,
            selectedSiteId,
            sites,
            baseurl,
            riskRegisterId,
            onSubCategorySelected,
            levelToClass,
            getsites,
            openModal,
            closeModal,
            getRiskDetailsById,
            updateRiskScore,
            CreateRiskClicked,
            closeRiskReg,
            addRiskRegister,
            
        };
    }
}